export default {
    day: '2023-09-26',
    content: {
        meta: [
            {
                type: 'qol',
                text: '6',
            }
        ],
        mining: [
            {
                type: 'balance',
                text: '0',
            },
            {
                type: 'clarity',
                text: '1',
            },
            {
                unlock: 'miningDepthDweller',
                type: 'clarity',
                text: '8',
            }
        ],
        village: [
            {
                type: 'clarity',
                text: '2',
            },
            {
                type: 'clarity',
                text: '3',
            }
        ],
        achievement: [
            {
                type: 'clarity',
                text: '9',
            }
        ],
        school: [
            {
                type: 'qol',
                text: '4',
            },
            {
                type: 'context',
                text: '10',
            },
            {
                type: 'balance',
                text: '11',
                balance: 'nerf',
                before: '100%',
                after: '10% - 100%',
            },
            {
                type: 'balance',
                text: '12',
            },
            {
                unlock: 'schoolLiteratureSubfeature',
                type: 'bugfix',
                text: '13',
            }
        ],
        horde: [
            {
                unlock: 'hordePrestige',
                type: 'clarity',
                text: '7',
            }
        ],
        card: [
            {
                type: 'clarity',
                text: '5',
            }
        ],
    }
}
